/**
 * Verbundene Repositories eines Projekts und ihre Pipelines (NEX-1105/1106).
 *
 * Spiegelt `GET /api/v1/projects/{projectId}/repositories` und dessen
 * `/{repositoryId}/pipelines`.
 */

/**
 * Das System, in dem Repository und Pipelines liegen. Heute liefert das Backend
 * ausschliesslich `GITHUB`; weitere Werte kommen dort als Enum-Konstanten dazu.
 * Bewusst keine Vorratsliste im Frontend — eine Anzeige fuer einen Provider, den
 * das Backend nicht kennt, waere toter Code, der still auseinanderlaeuft.
 *
 * Die Liste zur Laufzeit steht neben dem Typ, weil der Wert aus JSON kommt und
 * der Typ ihn deshalb nicht garantiert: was hier nicht steht, hat auch keinen
 * uebersetzten Namen und wird roh angezeigt.
 */
export const REPOSITORY_PROVIDERS = ['GITHUB'] as const;
export type RepositoryProvider = (typeof REPOSITORY_PROVIDERS)[number];

export interface RepositoryBinding {
  id: string;
  provider: RepositoryProvider;
  repoUrl: string;
  /** Leer, solange kein Branch gepflegt und kein Verbindungstest gelaufen ist. */
  branch: string | null;
}

/**
 * Eine auswaehlbare Pipeline. `file` ist der Pfad im Repository und zugleich die
 * Identitaet — genau dieser Wert gehoert in `repositoryPipeline.pipeline` beim
 * Anlegen des Laufs. Der Name dient nur der Anzeige.
 */
export interface RepositoryPipeline {
  file: string;
  name: string;
  steps: string[];
}

/**
 * Die Antwort der Pipeline-Abfrage: die Pipelines und der Branch, von dem sie
 * gelesen wurden. Ohne gepflegten Branch nennt `branch` den Default-Branch des
 * Repositories — die Liste der Repositories kennt ihn nicht, weil er dort je
 * Eintrag einen Aufruf beim Anbieter kosten wuerde. `null` steht dafuer, dass
 * der Branch nicht zu ermitteln war; die Karte nennt dann keinen.
 */
export interface RepositoryPipelines {
  branch: string | null;
  pipelines: RepositoryPipeline[];
}
